import { useEffect, useState } from "react";
import { isMobile } from '../util/utilMobile';
import DataTable from "react-data-table-component";

const getColumns = (data) => {
  data.forEach((element, index) => {
    if (
      element.name.indexOf("ID") !== -1 ||
      element.name.indexOf("Estado") !== -1 ||
      element.name.indexOf("RSFV") !== -1 ||
      element.name.indexOf("Sucursal") !== -1
    ) {
      delete data[index];
    } else {
      if (isMobile()) {
        switch (element.name) {
          case 'Cliente':
          case 'Descripcion':
          case 'RegistroSanitario':
          case 'Cantidad':
            element.omit = true;
            break;
        }
      }
      element.sortable = true;
      element.selector = (row) => row[element.name];
      element.style = {
        background: "transparent",
      };
    }
  });
  return data;
};
const TableComponent = ({ dataComponent, entity, handleOpenModal }) => {
  const [state, setState] = useState({
    filtro: "",
  });
  const conditionalRowStyles = [
    {
      when: (row) => {
        return row.toggleSelected;
      },
      style: {
        backgroundColor: "#E2EED8",
        userSelect: "none",
      },
    },
  ];
  useEffect(() => {
    const columns = getColumns(dataComponent.columns);
    switch (entity.toUpperCase()) {
      case 'CABECERA':
        setState({
          filtro: state.filtro,
          placeholder: 'Filtrar por guía',
          columns: columns,
        });
        break;
      case 'DETALLE':
        setState({
          filtro: state.filtro,
          placeholder: isMobile() ? 'Filtrar datos' : 'Filtrar por codigo, descripción o lote',
          columns: columns,
        });
        break;
    }
  }, []);
  const onFilter = (e) => {
    setState({
      filtro: e.target.value.toUpperCase(),
      placeholder: state.placeholder,
      columns: state.columns,
    });
  };
  const onData = (data) => {
    switch (entity.toUpperCase()) {
      case 'CABECERA':
        return data.filter((item) => item.Guia && item.Guia.includes(state.filtro));
      case 'DETALLE':
        return data.filter((item) => item.Codigo.includes(state.filtro) || item.Descripcion.includes(state.filtro) || item.Lote.includes(state.filtro));
    }
    return data;
  };
  return (
    <>
      <div className="flex flex-col w-full">
        <div className="flex md:justify-end sm:justify-start">
          <div className="mb-3 flex flex-row md:gap-0 md:w-[29%] gap-9">
            <label className="w-[60%] flex justify-end mr-2 pt-1 text-left">{state.placeholder}</label>
            <input
              type="text"
              className="
        md:w-[40%]
        w-full
        form-control
        block
        px-3
        py-1.5
        text-base
        font-normal
        text-gray-700
        bg-white bg-clip-padding
        border border-solid border-gray-300
        rounded
        transition
        ease-in-out
        m-0
        focus:text-gray-700 focus:bg-white focus:border-green-600 focus:outline-none
      "
              id="exampleText0"
              value={state.filtro}
              onChange={onFilter}
            />
          </div>
        </div>
        <div className="w-full">
          <DataTable
            columns={state.columns}
            data={onData(dataComponent.data)}
            onRowDoubleClicked={handleOpenModal}
            conditionalRowStyles={conditionalRowStyles}
            noDataComponent='No se encontraron resultados con los filtros ingresados.' 
            responsive
            persistTableHead
          />
        </div>
      </div>
    </>
  );
};
export default TableComponent;
